import { ExtraButtonsInterface } from '../../interfaces/extra-buttons/extra-buttons-interface';

export class ExtraButtonsModel implements ExtraButtonsInterface {
  tag: string = '';
  severity: 'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' = 'primary';
  label: string = '';
  icon: string = '';
  loading: boolean = false;
  disabled: boolean = false;
  type?: 'NORMAL' | 'UPLOAD' = 'NORMAL';

  constructor(init?: Partial<ExtraButtonsModel>) {
    Object.assign(this, init);
  }
}
